module.exports = __webpack_public_path__ + "media/8.b3f02dd3.mp3";